export default __webpack_public_path__ + "static/media/IR.b838442b.svg";